module.exports = __webpack_public_path__ + "static/media/discord_sm.7141b30bc795ad1910f8cd8eba737ee7.svg";